import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        id: "Layer_2",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 742.3 744.4"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "linear-gradient",
                        x1: -165.62,
                        y1: -997.87,
                        x2: -792.78,
                        y2: -635.79,
                        gradientTransform: "translate(851 1190.76)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0,
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#989898"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "linear-gradient-2",
                        x1: -251.09,
                        y1: -82.52,
                        x2: -318.54,
                        y2: -164.08,
                        gradientTransform: "translate(564 698.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0,
                                stopColor: "#00cbfd"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#006acf"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "linear-gradient-3",
                        x1: 74.83,
                        y1: -357.89,
                        x2: -352.93,
                        y2: -380.01,
                        gradientTransform: "translate(564 698.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0,
                                stopColor: "#00c5ff"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#006acf"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "linear-gradient-4",
                        x1: -376.81,
                        y1: -254.49,
                        x2: -6.24,
                        y2: -250.97,
                        gradientTransform: "translate(564 698.31)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0,
                                stopColor: "#0086dd"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#00cbfd"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("linearGradient", {
                        id: "linear-gradient-5",
                        x1: 120.08,
                        y1: 6621.81,
                        x2: -507.08,
                        y2: 6259.73,
                        gradientTransform: "matrix(1 0 0 -1 564 6811.27)",
                        xlinkHref: "#linear-gradient"
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "New_Gradient_Swatch_1",
                        x1: -252.98,
                        y1: -700.73,
                        x2: -327.85,
                        y2: -793.19,
                        gradientTransform: "translate(564 1306.32)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0,
                                stopColor: "#8247e4"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0.99,
                                stopColor: "#702d9c"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("linearGradient", {
                        id: "New_Gradient_Swatch_1-2",
                        x1: 45.28,
                        y1: -976.51,
                        x2: -376.68,
                        y2: -998.63,
                        xlinkHref: "#New_Gradient_Swatch_1"
                    }),
                    /*#__PURE__*/ _jsx("linearGradient", {
                        id: "New_Gradient_Swatch_1-3",
                        x1: -367.75,
                        y1: -871.51,
                        x2: -19.02,
                        y2: -868.22,
                        xlinkHref: "#New_Gradient_Swatch_1"
                    }),
                    /*#__PURE__*/ _jsx("style", {
                        children: ".cls-2{fill:#fff}"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "Layer_1-2",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "b",
                    children: /*#__PURE__*/ _jsxs("g", {
                        id: "c",
                        children: [
                            /*#__PURE__*/ _jsx("g", {
                                id: "d",
                                children: /*#__PURE__*/ _jsxs("g", {
                                    id: "e",
                                    children: [
                                        /*#__PURE__*/ _jsx("g", {
                                            id: "f",
                                            children: /*#__PURE__*/ _jsx("g", {
                                                id: "g",
                                                children: /*#__PURE__*/ _jsx("g", {
                                                    id: "h",
                                                    children: /*#__PURE__*/ _jsxs("g", {
                                                        id: "i",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M371.8 735.9c-200-.1-362-162.4-361.9-362.3C10 228.2 97 97 230.9 40.4c184.5-77.2 396.6 9.7 473.8 194.2 76.9 183.6-8.9 394.9-192 473-44.5 18.7-92.5 28.4-140.9 28.3Z",
                                                                style: {
                                                                    fill: "url(#linear-gradient)"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("path", {
                                                                className: "cls-2",
                                                                d: "M371.8 20.4c195.3.1 353.5 158.5 353.4 353.8-.1 141.9-85.1 270.1-215.8 325.4-180.2 75.3-387.3-9.8-462.6-190-74.9-179.2 8.8-385.2 187.4-461.5 43.5-18.4 90.3-27.8 137.6-27.7m0-17C167.2 3.4 1.3 169.3 1.3 373.9s165.9 370.5 370.5 370.5 370.5-165.9 370.5-370.5S576.4 3.4 371.8 3.4Z"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("g", {
                                            id: "k",
                                            children: /*#__PURE__*/ _jsx("g", {
                                                id: "l",
                                                children: /*#__PURE__*/ _jsxs("g", {
                                                    id: "m",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M195.6 602.5h130.6v-99.2h-31.4c-54.8-.1-99.2 44.4-99.2 99.2Z",
                                                            style: {
                                                                fill: "url(#linear-gradient-2)"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M609.5 329.2c.5 94.1-74.1 171.3-168.1 174.1 59.5-2.1 106-52.1 103.9-111.7-2.1-58-49.7-104-107.8-104H326.3c-72.1 0-130.6-58.5-130.6-130.6h238.8c95.5 0 174.5 76.6 175 172.2Z",
                                                            style: {
                                                                fill: "url(#linear-gradient-3)"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx("path", {
                                                            d: "M437.5 287.6c22.8.6 41 19 41.4 41.8.4 23.8-19.6 43.3-43.4 43.3H326.2c-72.1 0-130.6 58.5-130.6 130.6v99.2c0-53.6 42.6-97.5 96.2-99.2 0 0 149 0 149.6-.1 59.5-2.1 106-52.1 103.9-111.7-2.1-57.9-49.8-103.9-107.8-103.9Z",
                                                            style: {
                                                                fill: "url(#linear-gradient-4)"
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("g", {
                                id: "q",
                                children: /*#__PURE__*/ _jsx("g", {
                                    id: "r",
                                    children: /*#__PURE__*/ _jsx("g", {
                                        id: "s",
                                        children: /*#__PURE__*/ _jsx("g", {
                                            id: "t",
                                            children: /*#__PURE__*/ _jsx("g", {
                                                id: "u",
                                                children: /*#__PURE__*/ _jsx("g", {
                                                    id: "v",
                                                    children: /*#__PURE__*/ _jsx("g", {
                                                        id: "w",
                                                        children: /*#__PURE__*/ _jsxs("g", {
                                                            id: "x",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("path", {
                                                                    d: "M370.5 732.5c-200-.1-362-162.4-361.9-362.3.1-145.4 87.1-276.6 221-333.2 184.5-77.2 396.6 9.7 473.8 194.2 76.9 183.6-8.9 394.9-192 472.9-44.5 18.8-92.5 28.5-140.9 28.4Z",
                                                                    style: {
                                                                        fill: "url(#linear-gradient-5)"
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ _jsx("path", {
                                                                    className: "cls-2",
                                                                    d: "M370.5 17c195.3.1 353.5 158.6 353.4 353.8-.1 141.9-85.1 270.1-215.8 325.4-180.2 75.3-387.3-9.8-462.6-190C-29.4 327.1 54.3 121 232.9 44.7c43.5-18.4 90.3-27.8 137.6-27.7m0-17C165.9 0 0 165.9 0 370.5S165.9 741 370.5 741 741 575.1 741 370.5 575.1 0 370.5 0Z"
                                                                }),
                                                                /*#__PURE__*/ _jsxs("g", {
                                                                    id: "a_",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M195.6 593.3h130.6v-99.2h-31.4c-54.8 0-99.2 44.4-99.2 99.2Z",
                                                                            style: {
                                                                                fill: "url(#New_Gradient_Swatch_1)"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M609.5 320c.5 94.1-74.1 171.4-168.1 174.1 59.5-2.1 106-52.1 103.9-111.7-2.1-58-49.7-104-107.8-104H326.3c-72.1 0-130.6-58.5-130.6-130.6h238.8c95.5 0 174.5 76.6 175 172.2Z",
                                                                            style: {
                                                                                fill: "url(#New_Gradient_Swatch_1-2)"
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M437.5 278.5c22.8.6 41 19 41.5 41.8.4 23.8-19.6 43.3-43.4 43.3H326.3c-72.1 0-130.6 58.5-130.6 130.6v99.2c0-53.6 42.6-97.5 96.2-99.2 0 0 149 0 149.6-.1 59.5-2.1 106-52.1 103.9-111.7-2.2-58-49.9-104-107.9-103.9Z",
                                                                            style: {
                                                                                fill: "url(#New_Gradient_Swatch_1-3)"
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
export default Icon;
